module.exports = __webpack_public_path__ + "img/A_2_correct.a656bf16.png";